import fetch from 'auth/FetchInterceptor'

const MaintenanceService = {}

MaintenanceService.addMaintenanceRecord = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/MaintenanceRecord',
        method: 'post',
        data: data,
    })
}

MaintenanceService.getMaintenanceRecords = function (params) {
    return fetch({
        url:
            process.env.REACT_APP_API_URL +
            `portal/MaintenanceRecord/GetMaintenanceRecordsDynamic?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

MaintenanceService.deleteMaintenanceRecord = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/MaintenanceRecord/${params}`,
        method: 'delete',
        params,
    })
}

MaintenanceService.getMaintenanceRecordDetail = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/MaintenanceRecord/${params}`,
        method: 'get',
        params,
    })
}

MaintenanceService.updateMaintenanceRecord = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/MaintenanceRecord',
        method: 'put',
        data: data,
    })
}

MaintenanceService.uploadAttachments = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/MaintenanceRecord/UploadAttachments',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
    })
}

MaintenanceService.deleteAttachment = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/MaintenanceRecord/DeleteMaintenanceRecordAttachment/${params}`,
        method: 'delete',
        params,
    })
}

MaintenanceService.getRecordsToExcel = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/MaintenanceRecord/GetMaintenanceRecordsExcel',
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}

MaintenanceService.getChecklistTasks = function (maintenanceRecordId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/MaintenanceRecord/checklists/${maintenanceRecordId}`,
        method: 'post',
    })
}

MaintenanceService.updateChecklistTasks = function (checklistData) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/MaintenanceRecord/checklists',
        method: 'put',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: checklistData,
    })
}

MaintenanceService.getMaintenanceRecordChecklistId = function (maintenanceRecordId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/MaintenanceRecord/${maintenanceRecordId}/checklists`,
        method: 'get',
    })
}

MaintenanceService.getChecklistTasksById = function (checklistId) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/MaintenanceRecord/checklists/${checklistId}`,
        method: 'get',
    })
}

export default MaintenanceService
